import { render, staticRenderFns } from "./Delaystrategytemp.vue?vue&type=template&id=0ffba8fc&scoped=true"
import script from "./Delaystrategytemp.vue?vue&type=script&lang=js"
export * from "./Delaystrategytemp.vue?vue&type=script&lang=js"
import style0 from "./Delaystrategytemp.vue?vue&type=style&index=0&id=0ffba8fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffba8fc",
  null
  
)

export default component.exports